import Vue from "vue";
import Vuex from "vuex";
import AuthStore from "@/store/modules/auth";
import UserStore from "@/store/modules/user";
import SidebarStore from "@/store/modules/sidebar";
import FloatMenuStore from "@/store/modules/floatMenu";
import SpaceStore from "@/store/modules/space";
import GraphicClientStore from "@/store/modules/graphicClient";
import MeetingStore from "@/store/modules/meeting";
import SpaceUserStore from "@/store/modules/spaceUser";
import ChatStore from "@/store/modules/chat";
import SystemStore from "@/store/modules/system";
import WorkerStore from "@/store/modules/worker";
import InvitationStore from "@/store/modules/invitation";
import AdminStore from "@/store/modules/admin";
import SpeedNetworkingStore from "@/store/modules/speedNetworking";
import DashboardStore from "@/store/modules/dashboard";
import SuperSpaceStore from "@/store/modules/superSpace";
import SuperSpaceUserStore from "@/store/modules/superSpaceUser";
import LogsStore from "@/store/modules/logs";
import AnnouncementsStore from "@/store/modules/announcements";
import WebinarStore from "@/store/modules/webinar";
import Teams from "@/store/modules/teams";
import PollStore from "@/store/modules/poll";
import HawkingsStore from "@/store/modules/hawkings";
import GameKillerStore from "@/store/modules/gameKiller";
Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    UserStore,
    AuthStore,
    SidebarStore,
    FloatMenuStore,
    SpaceStore,
    GraphicClientStore,
    MeetingStore,
    SpaceUserStore,
    ChatStore,
    SystemStore,
    WorkerStore,
    InvitationStore,
    AdminStore,
    SpeedNetworkingStore,
    DashboardStore,
    SuperSpaceStore,
    SuperSpaceUserStore,
    LogsStore,
    AnnouncementsStore,
    WebinarStore,
    Teams,
    PollStore,
    HawkingsStore,
    GameKillerStore
  },
});
